import ErrorInfo from './responseErrorInfo';
import PagingInfo from './responsePagingInfo';
import Link from './resourceLink';

export default class ResponseInfo {
  /** HTTP Status code */
  statusCode: number | null = null;
  /** HTTP Status message */
  statusMessage: string = '';
  pagingInfo: PagingInfo | null = null;
  isError: boolean = false;
  errorInfo: ErrorInfo | null = null;
  /** HATEOAS Links */
  links: Array<Link> | null = null;
  /** API Version */
  version: string | null = null;
}
